export default {
  clientList: (state) => state.clientList,
};
